import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import moment from 'moment';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectStepBaggageAndPersonalItems, makeSelectStepBaggageAndPersonalItemsErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';
import { makeSelectInsuredsList, makeSelectIsClaimForFieldEnabled } from '../../App/selectors';
import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ValidateGroup,
  Validate,
  ErrorMessage,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetFormTravelInterruption,
  resetFormTravelDelay,
} from './actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import {
  makeSelectDepreciationTypes,
} from '../../ClaimList/selectors';
import { DescriptionListForBaggageDelay } from './components/DescriptionOfItemForBaggageDelay';
import { DescriptionList } from './components/DescriptionOfItem';
import { SpecifiedItemList } from './components/SpecifiedItem';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import TimePickerInput from '../../../components/TimePickerInput';
import { stepBaggageAndPersonalItemsExpenseLookup } from '../dataMapper/claimCodeMapper';
import { required, checkDateOnly } from '../../../utils/validation/validator';

export class StepBaggageAndPersonalItems extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(6);
  };

  onDescriptionOfItemsChange = (data) => {
    this.props.onFormDataChange('form.descriptionOfItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onDescriptionOfItemsForBaggageDelayChange = (data) => {
    this.props.onFormDataChange('form.descriptionOfItemsForDamaged', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onSpecifiedItems = (data) => {
    this.props.onFormDataChange('form.specifiedItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const {
      areYouClaimingForDamagedLostOrStolenLuggage,
      areYouClaimingForBaggageDelay,
    } = this.props.form;
    const isSelectBenefit = areYouClaimingForDamagedLostOrStolenLuggage === 'true' || areYouClaimingForBaggageDelay === 'true';
    const valid = isSelectBenefit && this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  handleNext = () => {
    const {
      areYouClaimingForDamagedLostOrStolenLuggage,
      areYouClaimingForBaggageDelay,
    } = this.props.form;
    const isSelectBenefit = areYouClaimingForDamagedLostOrStolenLuggage === 'true' || areYouClaimingForBaggageDelay === 'true';
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = isSelectBenefit && this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    // this.props.makeDirty(6);
  };

  handleReasonsForTripInterruption = (propertyName) => (event) => {
    const { reasonsForTripInterruption } = this.props.form;
    const reasons = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
      ? reasonsForTripInterruption.toJS()
      : reasonsForTripInterruption || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleChangeClaimingFor = (propertyName) => (event) => {
    const target = event.target;
    const value = target.name;
    this.props.onFormDataChange(propertyName, value);
  };

  handleReasonsForDelay = (propertyName) => (event) => {
    const { reasonsForDelay } = this.props.form;
    const reasons = !!reasonsForDelay && typeof reasonsForDelay.toJS === 'function'
      ? reasonsForDelay.toJS()
      : reasonsForDelay || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  renderDescriptionOfItemsForBaggageDelay() {
    const { descriptionOfItemsForDamaged } = this.props.form;
    const newDescriptionOfItemsForDamaged = this.appendIds(descriptionOfItemsForDamaged);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <DescriptionListForBaggageDelay
          data={newDescriptionOfItemsForDamaged}
          onChange={this.onDescriptionOfItemsForBaggageDelayChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderForBaggageDelay() {
    const {
      areYouClaimingForBaggageDelay,
      companyBaggageDelay,
      travelSupplierInformation,
      originForBaggageDelay,
      flightNumberOriginForBaggageDelay,
      airCarrierOriginForBaggageDelay,
      destinationForBaggageDelay,
      flightNumberDestinationForBaggageDelay,
      airCarrierDestinationForBaggageDelay,
      dateWhenYourLuggageWasDelayed,
      timeWhenYourLuggageWasDelayed,
      dateWhenYourLuggageWasReturned,
      timeWhenYourLuggageWasReturned,
      haveYouMadeAClaimWithYourTravelProvider,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const newTimeWhenYourLuggageWasDelayed = timeWhenYourLuggageWasDelayed ? moment(timeWhenYourLuggageWasDelayed) : null;
    const newTimeWhenYourLuggageWasReturned = timeWhenYourLuggageWasReturned ? moment(timeWhenYourLuggageWasReturned) : null;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      areYouClaimingForBaggageDelay === 'true' && (
        <div>
          <div className={'ml-5'}>
            <div className={'row'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelSupplierWhereDelayOccurred} />
              </PageSectionHeader>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="companyBaggageDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={companyBaggageDelay}
                  fieldName={messages.companyYouWereTravelingWith}
                >
                  <Textbox
                    name="companyBaggageDelay"
                    type="text"
                    onChange={this.handleChange('form.companyBaggageDelay')}
                    value={companyBaggageDelay}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.companyYouWereTravelingWith}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'row ml-2'}>
              <div className={'col-sm-12 form-group'}>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      name="Tour Operator"
                      checked={travelSupplierInformation === 'Tour Operator'}
                      onChange={this.handleChangeClaimingFor('form.travelSupplierInformation')}
                    />
                    <FormattedMessage {...messages.tourOperator} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      name="Cruise Line"
                      checked={travelSupplierInformation === 'Cruise Line'}
                      onChange={this.handleChangeClaimingFor('form.travelSupplierInformation')}
                    />
                    <FormattedMessage {...messages.cruiseLine} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      name="Airline"
                      checked={travelSupplierInformation === 'Airline'}
                      onChange={this.handleChangeClaimingFor('form.travelSupplierInformation')}
                    />
                    <FormattedMessage {...messages.airline} />
                  </OptionsContainer>
                </FlexBox>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="originForBaggageDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={originForBaggageDelay}
                  fieldName={messages.origin}
                >
                  <Textbox
                    name="originForBaggageDelay"
                    type="text"
                    onChange={this.handleChange('form.originForBaggageDelay')}
                    value={originForBaggageDelay}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.origin}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="flightNumberOriginForBaggageDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={flightNumberOriginForBaggageDelay}
                  fieldName={messages.flightNumber}
                >
                  <Textbox
                    name="flightNumberOriginForBaggageDelay"
                    type="text"
                    onChange={this.handleChange('form.flightNumberOriginForBaggageDelay')}
                    value={flightNumberOriginForBaggageDelay}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.flightNumber}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="airCarrierOriginForBaggageDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={airCarrierOriginForBaggageDelay}
                  fieldName={messages.airCarrier}
                >
                  <Textbox
                    name="airCarrierOriginForBaggageDelay"
                    type="text"
                    onChange={this.handleChange('form.airCarrierOriginForBaggageDelay')}
                    value={airCarrierOriginForBaggageDelay}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.airCarrier}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="destinationForBaggageDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={destinationForBaggageDelay}
                  fieldName={messages.destination}
                >
                  <Textbox
                    name="destinationForBaggageDelay"
                    type="text"
                    onChange={this.handleChange('form.destinationForBaggageDelay')}
                    value={destinationForBaggageDelay}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.destination}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="flightNumberDestinationForBaggageDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={flightNumberDestinationForBaggageDelay}
                  fieldName={messages.flightNumber}
                >
                  <Textbox
                    name="flightNumberDestinationForBaggageDelay"
                    type="text"
                    onChange={this.handleChange('form.flightNumberDestinationForBaggageDelay')}
                    value={flightNumberDestinationForBaggageDelay}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.flightNumber}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="airCarrierDestinationForBaggageDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={airCarrierDestinationForBaggageDelay}
                  fieldName={messages.airCarrier}
                >
                  <Textbox
                    name="airCarrierDestinationForBaggageDelay"
                    type="text"
                    onChange={this.handleChange('form.airCarrierDestinationForBaggageDelay')}
                    value={airCarrierDestinationForBaggageDelay}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.airCarrier}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
          </div>
          <div className={'ml-2'}>
            <div className="row">
              <div className="form-group col-md-6 col-sm-6">
                <Validate
                  name="dateWhenYourLuggageWasDelayed"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateWhenYourLuggageWasDelayed}
                  fieldName={messages.dateWhenYourLuggageWasDelayed}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateWhenYourLuggageWasDelayed"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateWhenYourLuggageWasDelayed')}
                    value={dateWhenYourLuggageWasDelayed}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateWhenYourLuggageWasDelayed}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateWhenYourLuggageWasDelayed}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-5 col-sm-5">
                <Validate
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  name="timeWhenYourLuggageWasDelayed"
                  group={this.validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  defaultValue={newTimeWhenYourLuggageWasDelayed}
                  fieldName={messages.timeWhenYourLuggageWasDelayed}
                >
                  <TimePickerInput
                    allowEmpty
                    showSecond={false}
                    onChange={this.onChange('form.timeWhenYourLuggageWasDelayed')}
                    value={newTimeWhenYourLuggageWasDelayed}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.timeWhenYourLuggageWasDelayed}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-md-1 col-sm-1 form-group'}>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6 col-sm-6">
                <Validate
                  name="dateWhenYourLuggageWasReturned"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateWhenYourLuggageWasReturned}
                  fieldName={messages.dateWhenYourLuggageWasReturned}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateWhenYourLuggageWasReturned"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateWhenYourLuggageWasReturned')}
                    value={dateWhenYourLuggageWasReturned}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateWhenYourLuggageWasReturned}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateWhenYourLuggageWasReturned}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-5 col-sm-5">
                <Validate
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  name="timeWhenYourLuggageWasReturned"
                  group={this.validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  defaultValue={newTimeWhenYourLuggageWasReturned}
                  fieldName={messages.timeWhenYourLuggageWasReturned}
                >
                  <TimePickerInput
                    allowEmpty
                    showSecond={false}
                    onChange={this.onChange('form.timeWhenYourLuggageWasReturned')}
                    value={newTimeWhenYourLuggageWasReturned}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.timeWhenYourLuggageWasReturned}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-md-1 col-sm-1 form-group'}>
              </div>
            </div>
          </div>
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.haveYouMadeAClaimWithYourTravelProvider} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={haveYouMadeAClaimWithYourTravelProvider === 'true'}
                    onChange={this.handleChange('form.haveYouMadeAClaimWithYourTravelProvider')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={haveYouMadeAClaimWithYourTravelProvider === 'false'}
                    onChange={this.handleChange('form.haveYouMadeAClaimWithYourTravelProvider')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
          <div className={'ml-2'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.descriptionOfItems} />
            </PageSectionHeader>
            {this.renderDescriptionOfItemsForBaggageDelay()}
          </div>
          {/* {this.renderInsuranceForBaggageDelay()} */}
        </div>
      )
    );
  }

  renderDescriptionOfItems() {
    const { descriptionOfItems } = this.props.form;
    const newDescriptionOfItems = this.appendIds(descriptionOfItems);
    const { isSummary, submitted, depreciationTypes, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <DescriptionList
          data={newDescriptionOfItems}
          onChange={this.onDescriptionOfItemsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          depreciationTypes={depreciationTypes}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderInsuranceForBaggageLoss() {
    const {
      doYouHaveOtherTypeOfInsuranceBaggageLoss,
      companyNameBaggageLoss,
      addressBaggageLoss,
      cityOrTownBaggageLoss,
      countryBaggageLoss,
      postalCodeBaggageLoss,
      typeOfPolicyBaggageLoss,
      policyBaggageLoss,
      contactBaggageLoss,
      phoneBaggageLoss,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <div className={'ml-1 row'}>
          <div className={'col-sm-7 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.doYouHaveAnyOtherTypeOfInsurance} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={doYouHaveOtherTypeOfInsuranceBaggageLoss === 'true'}
                    onChange={this.handleChange('form.doYouHaveOtherTypeOfInsuranceBaggageLoss')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={doYouHaveOtherTypeOfInsuranceBaggageLoss === 'false'}
                    onChange={this.handleChange('form.doYouHaveOtherTypeOfInsuranceBaggageLoss')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
          </div>
          <div className={'col-sm-5 form-group'}></div>
        </div>
        {doYouHaveOtherTypeOfInsuranceBaggageLoss === 'true' &&
          <div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="companyName"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={companyNameBaggageLoss}
                  fieldName={messages.companyName}
                >
                  <Textbox
                    name="companyNameBaggageLoss"
                    type="text"
                    onChange={this.handleChange('form.companyNameBaggageLoss')}
                    value={companyNameBaggageLoss}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.companyName}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="addressBaggageLoss"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={addressBaggageLoss}
                  fieldName={messages.address}
                >
                  <Textbox
                    name="address"
                    type="text"
                    onChange={this.handleChange('form.addressBaggageLoss')}
                    value={addressBaggageLoss}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.address}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="cityOrTownBaggageLoss"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={cityOrTownBaggageLoss}
                  fieldName={messages.cityOrTown}
                >
                  <Textbox
                    name="cityOrTownBaggageLoss"
                    type="text"
                    onChange={this.handleChange('form.cityOrTownBaggageLoss')}
                    value={cityOrTownBaggageLoss}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.cityOrTown}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="countryBaggageLoss"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={countryBaggageLoss}
                  fieldName={messages.country}
                >
                  <Textbox
                    name="countryBaggageLoss"
                    type="text"
                    onChange={this.handleChange('form.countryBaggageLoss')}
                    value={countryBaggageLoss}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.country}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="postalCodeBaggageLoss"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={postalCodeBaggageLoss}
                  fieldName={messages.postalCode}
                >
                  <Textbox
                    name="cityOrTown"
                    type="text"
                    onChange={this.handleChange('form.postalCodeBaggageLoss')}
                    value={postalCodeBaggageLoss}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.postalCode}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="typeOfPolicy"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={typeOfPolicyBaggageLoss}
                  fieldName={messages.typeOfPolicy}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="typeOfPolicy"
                      type="text"
                      onChange={this.handleChange('form.typeOfPolicyBaggageLoss')}
                      value={typeOfPolicyBaggageLoss}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.typeOfPolicy}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="policy"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={policyBaggageLoss}
                  fieldName={messages.policy}
                >
                  <Textbox
                    name="cityOrTown"
                    type="text"
                    onChange={this.handleChange('form.policyBaggageLoss')}
                    value={policyBaggageLoss}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.policy}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="contact"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={contactBaggageLoss}
                  fieldName={messages.contact}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="contact"
                      type="text"
                      onChange={this.handleChange('form.contactBaggageLoss')}
                      value={contactBaggageLoss}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.contact}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="phoneNumber"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={phoneBaggageLoss}
                  fieldName={messages.phoneNumber}                  
                  >
                    <Textbox
                      disabled={isReadOnly}
                      name="phoneNumber"
                      type="text"
                      onChange={this.handleChangePhoneNumber('form.phoneBaggageLoss')}
                      value={phoneBaggageLoss}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.phoneNumber}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
          </div>}
      </div>
    );
  }

  renderForDamagedLostOrStolenLuggage() {
    const {
      areYouClaimingForDamagedLostOrStolenLuggage,
      areYouClaimingFor1,
      companyYouWereTravelingWith,
      areYouClaimingFor2,
      originForDamaged,
      flightNumberOriginForDamaged,
      airCarrierOriginForDamaged,
      destinationForDamaged,
      flightNumberDestinationForDamaged,
      airCarrierDestinationForDamaged,
      dateOfLoss,
      pleaseDescribeWhatOccurred,
      areYouClaimingFor3,
      ifOtherPleaseDescribeWhere,
      whoDidYouReportTo,
      ifOtherPleaseDescribe2,
      reportReferenceNumber,
      nameCustomerServiceDepartment,
      address,
      cityOrTown,
      country,
      postalCode,
      phoneNumber,
      contact,
      doYouHaveAnyFurtherDetailsToAdd,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      areYouClaimingForDamagedLostOrStolenLuggage === 'true' && (
        <div>
          <div className={'ml-5'}>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
              <Validate
                name="nationalIdOrVisa"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={areYouClaimingFor1}
                fieldName={messages.areYouClaimingForV2}
                >
                    <FlexBox>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="true"
                          name="Loss"
                          checked={areYouClaimingFor1 === 'Loss'}
                          onChange={this.handleChangeClaimingFor('form.areYouClaimingFor1')}
                        />
                        <FormattedMessage {...messages.loss} />
                      </OptionsContainer>
                    </FlexBox>
                    <FlexBox className={'pt-2'}>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="false"
                          name="Theft"
                          checked={areYouClaimingFor1 === 'Theft'}
                          onChange={this.handleChangeClaimingFor('form.areYouClaimingFor1')}
                        />
                        <FormattedMessage {...messages.theft} />
                      </OptionsContainer>
                    </FlexBox>
                    <FlexBox className={'pt-2'}>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="false"
                          name="Damage"
                          checked={areYouClaimingFor1 === 'Damage'}
                          onChange={this.handleChangeClaimingFor('form.areYouClaimingFor1')}
                        />
                        <FormattedMessage {...messages.damage} />
                      </OptionsContainer>
                    </FlexBox>
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.areYouClaimingForV2}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'row'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelSupplierProviderInformation} />
              </PageSectionHeader>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="companyYouWereTravelingWith"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={companyYouWereTravelingWith}
                  fieldName={messages.companyYouWereTravelingWith}
                  >
                    <Textbox
                      name="companyYouWereTravelingWith"
                      type="text"
                      onChange={this.handleChange('form.companyYouWereTravelingWith')}
                      value={companyYouWereTravelingWith}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.companyYouWereTravelingWith}
                      />
                    </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'row ml-2'}>
              <div className={'col-sm-12 form-group'}>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      name="Tour Operator"
                      checked={areYouClaimingFor2 === 'Tour Operator'}
                      onChange={this.handleChangeClaimingFor('form.areYouClaimingFor2')}
                    />
                    <FormattedMessage {...messages.tourOperator} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      name="Cruise Line"
                      checked={areYouClaimingFor2 === 'Cruise Line'}
                      onChange={this.handleChangeClaimingFor('form.areYouClaimingFor2')}
                    />
                    <FormattedMessage {...messages.cruiseLine} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      name="Airline"
                      checked={areYouClaimingFor2 === 'Airline'}
                      onChange={this.handleChangeClaimingFor('form.areYouClaimingFor2')}
                    />
                    <FormattedMessage {...messages.airline} />
                  </OptionsContainer>
                </FlexBox>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="originForDamaged"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={originForDamaged}
                  fieldName={messages.origin}
                  >
                    <Textbox
                      name="originForDamaged"
                      type="text"
                      onChange={this.handleChange('form.originForDamaged')}
                      value={originForDamaged}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.origin}
                      />
                    </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="flightNumberOriginForDamaged"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.flightNumberOriginForDamaged}
                  defaultValue={flightNumberOriginForDamaged}
                  fieldName={messages.flightNumber}
                  >
                    <Textbox
                      name="flightNumberOriginForDamaged"
                      type="text"
                      onChange={this.handleChange('form.flightNumberOriginForDamaged')}
                      value={flightNumberOriginForDamaged}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.flightNumber}
                      />
                    </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="airCarrierOriginForDamaged"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.airCarrierOriginForDamaged}
                  defaultValue={airCarrierOriginForDamaged}
                  fieldName={messages.airCarrier}
                  >
                    <Textbox
                      name="airCarrierOriginForDamaged"
                      type="text"
                      onChange={this.handleChange('form.airCarrierOriginForDamaged')}
                      value={airCarrierOriginForDamaged}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.airCarrier}
                      />
                    </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="destinationForDamaged"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.destinationForDamaged}
                  defaultValue={destinationForDamaged}
                  fieldName={messages.destination}
                  >
                    <Textbox
                      name="destinationForDamaged"
                      type="text"
                      onChange={this.handleChange('form.destinationForDamaged')}
                      value={destinationForDamaged}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.destination}
                      />
                    </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="flightNumberDestinationForDamaged"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.flightNumberDestinationForDamaged}
                  defaultValue={flightNumberDestinationForDamaged}
                  fieldName={messages.flightNumber}
                  >
                    <Textbox
                      name="flightNumberDestinationForDamaged"
                      type="text"
                      onChange={this.handleChange('form.flightNumberDestinationForDamaged')}
                      value={flightNumberDestinationForDamaged}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.flightNumber}
                      />
                    </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="airCarrierDestinationForDamaged"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.airCarrierDestinationForDamaged}
                  defaultValue={airCarrierDestinationForDamaged}
                  fieldName={messages.airCarrier}
                  >
                    <Textbox
                      name="airCarrierDestinationForDamaged"
                      type="text"
                      onChange={this.handleChange('form.airCarrierDestinationForDamaged')}
                      value={airCarrierDestinationForDamaged}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.airCarrier}
                      />
                    </ErrorMessage>
                </Validate>
              </div>
            </div>
          </div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.lossInformation} />
            </PageSectionHeader>
            <div className={'ml-3 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateOfLoss"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateOfLoss}
                  fieldName={messages.dateOfLoss}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateOfLoss"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateOfLoss')}
                    value={dateOfLoss}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateOfLoss}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateOfLoss}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
              </div>
              <div className={'col-sm-4 form-group'}>
              </div>
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="pleaseDescribeWhatOccurred"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.pleaseDescribeWhatOccurred}
                  defaultValue={pleaseDescribeWhatOccurred}
                  fieldName={messages.pleaseDescribeWhatOccurred}
                  >
                    <TextArea
                      disabled={isReadOnly}
                      name="pleaseDescribeWhatOccurred"
                      type="text"
                      onChange={this.handleChange('form.pleaseDescribeWhatOccurred')}
                      value={pleaseDescribeWhatOccurred}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.pleaseDescribeWhatOccurred}
                      />
                    </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.areYouClaimingFor} />
                </PageSectionHeader>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      name="Airport"
                      checked={areYouClaimingFor3 === 'Airport'}
                      onChange={this.handleChangeClaimingFor('form.areYouClaimingFor3')}
                    />
                    <FormattedMessage {...messages.airport} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      name="Hotel"
                      checked={areYouClaimingFor3 === 'Hotel'}
                      onChange={this.handleChangeClaimingFor('form.areYouClaimingFor3')}
                    />
                    <FormattedMessage {...messages.hotel} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      name="Rental Agency"
                      checked={areYouClaimingFor3 === 'Rental Agency'}
                      onChange={this.handleChangeClaimingFor('form.areYouClaimingFor3')}
                    />
                    <FormattedMessage {...messages.rentalAgency} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      name="Other"
                      checked={areYouClaimingFor3 === 'Other'}
                      onChange={this.handleChangeClaimingFor('form.areYouClaimingFor3')}
                    />
                    <FormattedMessage {...messages.other} />
                  </OptionsContainer>
                </FlexBox>
              </div>
              {areYouClaimingFor3 === 'Other' &&
                <div className={'col-sm-8 form-group'}>
                  <Validate
                    name="ifOtherPleaseDescribeWhere"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={ifOtherPleaseDescribeWhere}
                    fieldName={messages.ifOtherPleaseDescribeWhere}
                    >
                      <TextArea
                        disabled={isReadOnly}
                        name="ifOtherPleaseDescribeWhere"
                        type="text"
                        onChange={this.handleChange('form.ifOtherPleaseDescribeWhere')}
                        value={ifOtherPleaseDescribeWhere}
                        isSummary={isSummary}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.ifOtherPleaseDescribeWhere}
                        />
                      </ErrorMessage>
                  </Validate>
                </div>}
              {areYouClaimingFor3 !== 'Other' &&
                <div className={'col-sm-8 form-group'}>
                  <PageSectionHeader>
                    <FormattedMessage {...messages.ifOtherPleaseDescribeWhere} />
                  </PageSectionHeader>
                  <TextArea
                    disabled={isReadOnly}
                    name="ifOtherPleaseDescribe"
                    type="text"
                    onChange={this.handleChange('form.ifOtherPleaseDescribeWhere')}
                    value={ifOtherPleaseDescribeWhere}
                    isSummary={isSummary}
                  />
              </div>}
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.whoDidYouReportTo} />
                </PageSectionHeader>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      name="Police"
                      checked={whoDidYouReportTo === 'Police'}
                      onChange={this.handleChangeClaimingFor('form.whoDidYouReportTo')}
                    />
                    <FormattedMessage {...messages.police} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      name="Hotel"
                      checked={whoDidYouReportTo === 'Hotel'}
                      onChange={this.handleChangeClaimingFor('form.whoDidYouReportTo')}
                    />
                    <FormattedMessage {...messages.hotel} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      name="Hospital Management"
                      checked={whoDidYouReportTo === 'Hospital Management'}
                      onChange={this.handleChangeClaimingFor('form.whoDidYouReportTo')}
                    />
                    <FormattedMessage {...messages.hospitalManagement} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      name="Cruise Ship"
                      checked={whoDidYouReportTo === 'Cruise Ship'}
                      onChange={this.handleChangeClaimingFor('form.whoDidYouReportTo')}
                    />
                    <FormattedMessage {...messages.cruiseShip} />
                  </OptionsContainer>
                </FlexBox>
              </div>
              <div className={'mt-4 col-sm-3 form-group'}>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      name="Tour Guide"
                      checked={whoDidYouReportTo === 'Tour Guide'}
                      onChange={this.handleChangeClaimingFor('form.whoDidYouReportTo')}
                    />
                    <FormattedMessage {...messages.tourGuide} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      name="Other Report"
                      checked={whoDidYouReportTo === 'Other Report'}
                      onChange={this.handleChangeClaimingFor('form.whoDidYouReportTo')}
                    />
                    <FormattedMessage {...messages.other} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      name="Not Reported"
                      checked={whoDidYouReportTo === 'Not Reported'}
                      onChange={this.handleChangeClaimingFor('form.whoDidYouReportTo')}
                    />
                    <FormattedMessage {...messages.notReported} />
                  </OptionsContainer>
                </FlexBox>
              </div>
              {whoDidYouReportTo === 'Other Report' &&
              <div className={'col-sm-5 form-group'}>
                <Validate
                  name="pleaseDescribeWhatOccurred"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={ifOtherPleaseDescribe2}
                  fieldName={messages.ifOtherPleaseDescribe}
                  >
                    <TextArea
                      disabled={isReadOnly}
                      name="ifOtherPleaseDescribe2"
                      type="text"
                      onChange={this.handleChange('form.ifOtherPleaseDescribe2')}
                      value={ifOtherPleaseDescribe2}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.ifOtherPleaseDescribe}
                      />
                    </ErrorMessage>
                </Validate>
              </div>}
              {whoDidYouReportTo !== 'Other Report' &&
              <div className={'col-sm-5 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.ifOtherPleaseDescribe} />
                </PageSectionHeader>
                <TextArea
                  disabled={isReadOnly}
                  name="ifOtherPleaseDescribe"
                  type="text"
                  onChange={this.handleChange('form.ifOtherPleaseDescribe2')}
                  value={ifOtherPleaseDescribe2}
                  isSummary={isSummary}
                />
              </div>}
            </div>
          </div>
          {whoDidYouReportTo !== 'Not Reported' &&
          <div className={'ml-4'}>
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="reportReferenceNumber"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={reportReferenceNumber}
                  fieldName={messages.reportReferenceNumber}
                >
                <Textbox
                  name="reportReferenceNumber"
                  type="text"
                  onChange={this.handleChange('form.reportReferenceNumber')}
                  value={reportReferenceNumber}
                  disabled={isReadOnly}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.reportReferenceNumber}
                  />
                </ErrorMessage>
              </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="nameCustomerServiceDepartment"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={nameCustomerServiceDepartment}
                  fieldName={messages.nameCustomerServiceDepartment}
                >
                  <Textbox
                    name="nameCustomerServiceDepartment"
                    type="text"
                    onChange={this.handleChange('form.nameCustomerServiceDepartment')}
                    value={nameCustomerServiceDepartment}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.nameCustomerServiceDepartment}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="address"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={address}
                  fieldName={messages.address}
                >
                  <Textbox
                    name="address"
                    type="text"
                    onChange={this.handleChange('form.address')}
                    value={address}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.address}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="cityOrTown"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={cityOrTown}
                  fieldName={messages.cityOrTown}
                >
                  <Textbox
                    name="cityOrTown"
                    type="text"
                    onChange={this.handleChange('form.cityOrTown')}
                    value={cityOrTown}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.cityOrTown}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="country"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={country}
                  fieldName={messages.country}
                >
                  <Textbox
                    name="country"
                    type="text"
                    onChange={this.handleChange('form.country')}
                    value={country}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.country}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="postalCode"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={postalCode}
                  fieldName={messages.postalCode}
                >
                  <Textbox
                    name="postalCode"
                    type="text"
                    onChange={this.handleChange('form.postalCode')}
                    value={postalCode}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.postalCode}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="phoneNumber"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={phoneNumber}
                  fieldName={messages.phoneNumber}
                >
                  <Textbox
                    name="phoneNumber"
                    type="text"
                    onChange={this.handleChangePhoneNumber('form.phoneNumber')}
                    value={phoneNumber}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.phoneNumber}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="contact"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={contact}
                  fieldName={messages.contact}
                >
                  <Textbox
                    name="contact"
                    type="text"
                    onChange={this.handleChange('form.contact')}
                    value={contact}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.contact}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}></div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.doYouHaveAnyFurtherDetailsToAdd} />
                </PageSectionHeader>
                <TextArea
                  disabled={isReadOnly}
                  name="doYouHaveAnyFurtherDetailsToAdd"
                  type="text"
                  onChange={this.handleChange('form.doYouHaveAnyFurtherDetailsToAdd')}
                  value={doYouHaveAnyFurtherDetailsToAdd}
                  isSummary={isSummary}
                />
              </div>
            </div>
          </div>}
          {whoDidYouReportTo === 'Not Reported' &&
          <div className={'ml-4'}>
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.reportReferenceNumber} />
                </PageSectionHeader>
                <Textbox
                  name="reportReferenceNumber"
                  type="text"
                  onChange={this.handleChange('form.reportReferenceNumber')}
                  value={reportReferenceNumber}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.nameCustomerServiceDepartment} />
                </PageSectionHeader>
                <Textbox
                  name="nameCustomerServiceDepartment"
                  type="text"
                  onChange={this.handleChange('form.nameCustomerServiceDepartment')}
                  value={nameCustomerServiceDepartment}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.address} />
                </PageSectionHeader>
                <Textbox
                  name="address"
                  type="text"
                  onChange={this.handleChange('form.address')}
                  value={address}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.cityOrTown} />
                </PageSectionHeader>
                <Textbox
                  name="cityOrTown"
                  type="text"
                  onChange={this.handleChange('form.cityOrTown')}
                  value={cityOrTown}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.country} />
                </PageSectionHeader>
                <Textbox
                  name="country"
                  type="text"
                  onChange={this.handleChange('form.country')}
                  value={country}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.postalCode} />
                </PageSectionHeader>
                <Textbox
                  name="postalCode"
                  type="text"
                  onChange={this.handleChange('form.postalCode')}
                  value={postalCode}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.phoneNumber} />
                </PageSectionHeader>
                <Textbox
                  name="phoneNumber"
                  type="text"
                  onChange={this.handleChangePhoneNumber('form.phoneNumber')}
                  value={phoneNumber}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.contact} />
                </PageSectionHeader>
                <Textbox
                  name="contact"
                  type="text"
                  onChange={this.handleChange('form.contact')}
                  value={contact}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-4 form-group'}></div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.doYouHaveAnyFurtherDetailsToAdd} />
                </PageSectionHeader>
                <TextArea
                  disabled={isReadOnly}
                  name="doYouHaveAnyFurtherDetailsToAdd"
                  type="text"
                  onChange={this.handleChange('form.doYouHaveAnyFurtherDetailsToAdd')}
                  value={doYouHaveAnyFurtherDetailsToAdd}
                  isSummary={isSummary}
                />
              </div>
            </div>
          </div>}
          <div className={'ml-2'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.descriptionOfItems} />
            </PageSectionHeader>
            {this.renderDescriptionOfItems()}
          </div>
        </div>
      )
    );
  }

  renderSpecifiedItems() {
    const { specifiedItems } = this.props.form;
    const newSpecifiedItems = this.appendIds(specifiedItems);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <SpecifiedItemList
          data={newSpecifiedItems}
          onChange={this.onSpecifiedItems}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  render() {
    const {
      areYouClaimingForDamagedLostOrStolenLuggage,
      areYouClaimingForBaggageDelay,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, loading } = this.props;
    const isRenderAreYouClaimingForBaggageDelay = !!stepBaggageAndPersonalItemsExpenseLookup.areYouClaimingForBaggageDelay.claimCode;
    const isRenderAreYouClaimingForDamagedLostOrStolenLuggage = !!stepBaggageAndPersonalItemsExpenseLookup.areYouClaimingForDamaged.claimCode;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="app-content">
        {isRenderAreYouClaimingForDamagedLostOrStolenLuggage &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouClaimingForDamagedLostOrStolenLuggage} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={areYouClaimingForDamagedLostOrStolenLuggage === 'true'}
                    onChange={this.handleChange('form.areYouClaimingForDamagedLostOrStolenLuggage')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={areYouClaimingForDamagedLostOrStolenLuggage === 'false'}
                    onChange={this.handleChange('form.areYouClaimingForDamagedLostOrStolenLuggage')}
                    onClick={this.props.onResetFormTravelInterruption}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {isRenderAreYouClaimingForDamagedLostOrStolenLuggage && this.renderForDamagedLostOrStolenLuggage()}
        {isRenderAreYouClaimingForBaggageDelay &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouClaimingForBaggageDelay} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={areYouClaimingForBaggageDelay === 'true'}
                    onChange={this.handleChange('form.areYouClaimingForBaggageDelay')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={areYouClaimingForBaggageDelay === 'false'}
                    onChange={this.handleChange('form.areYouClaimingForBaggageDelay')}
                    onClick={this.props.onResetFormTravelDelay}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {isRenderAreYouClaimingForBaggageDelay && this.renderForBaggageDelay()}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

StepBaggageAndPersonalItems.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormTravelInterruption: PropTypes.func,
  onResetFormTravelDelay: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  depreciationTypes: PropTypes.any,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStepBaggageAndPersonalItems(),
  errors: makeSelectStepBaggageAndPersonalItemsErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  depreciationTypes: makeSelectDepreciationTypes(),
  insuredsList: makeSelectInsuredsList(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormTravelInterruption: () => dispatch(resetFormTravelInterruption()),
  onResetFormTravelDelay: () => dispatch(resetFormTravelDelay()),
  onResetFormData: () => dispatch(resetFormData()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'stepBaggageAndPersonalItems', reducer });

export default compose(
  withReducer,
  withConnect
)(StepBaggageAndPersonalItems);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepBaggageAndPersonalItems/index.js